<template lang="html">
  <div>
    <add-users-steps-bar
      :stepActive="stepActive"
      @nextScreen="nextScreen"
      v-if="screen < 2"
    />
    <add-users-second-step v-if="screen === 1" />
    <add-users-third-step v-else-if="screen === 2" />
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import addUsersStepsBar from './addUsersStepsBar';
  import addUsersSecondStep from './addUsersSecondStep';
  import addUsersThirdStep from './addUsersThirdStep';

  export default {
    data() {
      return {
        screen: '',
        //methodSelected: '',
        stepActive: null,
      };
    },
    components: {
      addUsersStepsBar,
      addUsersSecondStep,
      addUsersThirdStep,
    },
    methods: {
      selectCSV() {
        this.stepActive = 1;
      },
      nextScreen(screen) {
        this.screen = screen;
      },
    },
    created() {},
    mounted() {
      this.screen = 1;
      EventBus.$on('reloadAddUsers', () => (this.screen = 1));
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .selected-style {
    border-width: 5px;
    border-style: solid;
    color: pl-primary;
    border-color: pl-primary;
  }
</style>



// WEBPACK FOOTER //
// adminPortalAddUsers.vue?cc2c60fc